import { useEffect } from "react";

const DEFAULT_TITLE = "Biz-AI検定 | AI活用スキルを証明するビジネス検定";
const DEFAULT_DESCRIPTION =
  "AI活用の実務スキルを問うオンライン検定「Biz-AI検定」。無料のサンプル問題で腕試し！AssociateからSpecialistまで、あなたのAIリテラシーを証明するデジタルバッジを取得しましょう。全国どこからでもオンライン受験可能です。";

interface PageMetaOptions {
  title?: string;
  description?: string;
}

/**
 * ページごとの <title> と meta[name="description"] を動的に更新するフック。
 * コンポーネントのアンマウント時にデフォルト値へ戻す。
 */
export function usePageMeta({ title, description }: PageMetaOptions) {
  useEffect(() => {
    if (title) {
      document.title = title;
    }

    const metaDesc = document.querySelector<HTMLMetaElement>(
      'meta[name="description"]'
    );
    if (metaDesc && description) {
      metaDesc.setAttribute("content", description);
    }

    return () => {
      document.title = DEFAULT_TITLE;
      if (metaDesc) {
        metaDesc.setAttribute("content", DEFAULT_DESCRIPTION);
      }
    };
  }, [title, description]);
}
